<template>
  <svg
    width="101px"
    height="101px"
    viewBox="0 0 101 101"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
  >
    <!-- Generator: Sketch 3.3.2 (12043) - http://www.bohemiancoding.com/sketch -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
      <g id="jwt_logo" sketch:type="MSLayerGroup" transform="translate(-150.000000, -538.000000)">
        <g id="Group" transform="translate(0.000000, 413.000000)" sketch:type="MSShapeGroup">
          <g id="Shape" transform="translate(150.000000, 125.000000)">
            <g>
              <path d="M57.8,27.2 L57.7,0.3 L42.7,0.3 L42.8,27.2 L50.3,37.5 L57.8,27.2 Z" fill="#FFFFFF"></path>
              <path d="M42.8,73.3 L42.8,100.3 L57.8,100.3 L57.8,73.3 L50.3,63 L42.8,73.3 Z" fill="#FFFFFF"></path>
              <path d="M57.8,73.3 L73.6,95.1 L85.7,86.3 L69.9,64.5 L57.8,60.6 L57.8,73.3 Z" fill="#00F2E6"></path>
              <path d="M42.8,27.2 L26.9,5.4 L14.8,14.2 L30.6,36 L42.8,39.9 L42.8,27.2 Z" fill="#00F2E6"></path>
              <path d="M30.6,36 L5,27.7 L0.4,41.9 L26,50.3 L38.1,46.3 L30.6,36 Z" fill="#00B9F1"></path>
              <path d="M62.4,54.2 L69.9,64.5 L95.5,72.8 L100.1,58.6 L74.5,50.3 L62.4,54.2 Z" fill="#00B9F1"></path>
              <path d="M74.5,50.3 L100.1,41.9 L95.5,27.7 L69.9,36 L62.4,46.3 L74.5,50.3 Z" fill="#D63AFF"></path>
              <path d="M26,50.3 L0.4,58.6 L5,72.8 L30.6,64.5 L38.1,54.2 L26,50.3 Z" fill="#D63AFF"></path>
              <path d="M30.6,64.5 L14.8,86.3 L26.9,95.1 L42.8,73.3 L42.8,60.6 L30.6,64.5 Z" fill="#FB015B"></path>
              <path d="M69.9,36 L85.7,14.2 L73.6,5.4 L57.8,27.2 L57.8,39.9 L69.9,36 Z" fill="#FB015B"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
